'use client';
import {MediaQuery} from '@constants/theme';
import {styled} from '@mui/material/styles';
import {SlickCarousel} from '@new-components/atoms/SlickCarousel';

export const DesktopCarousel = styled(SlickCarousel)(({theme}) => ({
  [MediaQuery.mobile]: {
    display: 'none !important',
  },
}));
export const MobileCarousel = styled(SlickCarousel)(({theme}) => ({
  [MediaQuery.desktop]: {
    display: 'none !important',
  },
}));
